<ul class="nav nav-tabs" id="{{config.tabId}}">
  <li *ngFor="let tab of config.tabList; let index = index;" class="nav-item" id="tab-{{index}}" (click)="setActiveTab(tab, index)">
    <a class="nav-link" [class.active]="currentTab === tab.route" [class.disabled]="tab.isDisabled" [class.inactive]="tab.isDisabled" routerLink="{{tab.route}}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{tab.title}}</a>
  </li>
</ul>